import React from 'react'
import Navbar from '../components/Navbar'
import Video from '../components/Video'

function Home() {
  return (
    <div className='page'>
        <Navbar/>
        <Video/>
    </div>
  )
}

export default Home